module.exports = __webpack_public_path__ + "img/examen-2.a19697f4.svg";